import { RouteObject } from 'react-router-dom';
import { EDIT_PROJECT_ROUTES_CONFIG, convertConfigToRouteObject } from './shared/edit-project-routes.config';
import { EDIT_PROJECT_ROUTE_IDS } from './shared/edit-project-route-ids';

const EditProjectRoutes: RouteObject[] = [
  {
    path: ':projectUuid/*',
    id: EDIT_PROJECT_ROUTE_IDS.ROOT,
    shouldRevalidate: () => false,
    async lazy() {
      const PreviewTemplate = await import('./edit-project.view');
      return { Component: PreviewTemplate.default };
    },
    children: [
      {
        path: ':language/*',
        id: EDIT_PROJECT_ROUTE_IDS.ROOT_WITH_LANGUAGE,
        children: EDIT_PROJECT_ROUTES_CONFIG.map(convertConfigToRouteObject),
      },
    ],
  },
];

export default EditProjectRoutes;
